// ============================================================
// RASTREIO — camada de dados
// ------------------------------------------------------------
// V1 é DEMONSTRATIVA: não existe backend ainda, então toda busca
// responde "não encontrado". Toda a interface (loading, erro,
// resultado com linha do tempo) já está construída e testada.
//
// PARA LIGAR NO SISTEMA REAL, mexer só neste arquivo:
//   1. Trocar o corpo de `consultarRastreio` por um fetch na API
//   2. Devolver no mesmo formato de `RASTREIOS_DEMO` abaixo
//   3. Nenhum componente .vue precisa ser alterado
//
// PARA DEMONSTRAR PRA UM CLIENTE com um código que funciona,
// basta adicionar uma entrada em RASTREIOS_DEMO (a interface
// completa de resultado já está pronta e vai renderizar).
// ============================================================

export const PREFIXO_CODIGO = 'FDG'

// Formato aceito: FDG-000000 (3 letras, hífen, 6 dígitos).
// Também aceita sem hífen e em minúsculo — normalizado antes de validar.
const FORMATO = /^[A-Z]{3}-?\d{6}$/

// Aceita o que o visitante digitar (minúsculo, com/sem hífen, com espaço) e
// devolve sempre no formato canônico FDG-000000, pra exibição não variar.
export function normalizarCodigo(valor) {
  const limpo = String(valor || '').toUpperCase().replace(/[\s-]/g, '')
  const completo = limpo.match(/^([A-Z]{3})(\d{1,6})$/)
  return completo ? `${completo[1]}-${completo[2]}` : limpo
}

export function formatoValido(valor) {
  return FORMATO.test(normalizarCodigo(valor))
}

// Etapas do transporte — usadas tanto no resultado real quanto na
// seção ilustrativa "como funciona o acompanhamento" da página.
export const ETAPAS = [
  { chave: 'coletado', titulo: 'Carga coletada', desc: 'Mercadoria retirada no endereço de origem e conferida.', icone: 'mdi-package-variant-closed' },
  { chave: 'transito', titulo: 'Em trânsito', desc: 'Carga a caminho do destino com o motorista responsável.', icone: 'mdi-truck-fast-outline' },
  { chave: 'rota', titulo: 'Saiu para entrega', desc: 'Última etapa do percurso, a caminho do destinatário.', icone: 'mdi-map-marker-path' },
  { chave: 'entregue', titulo: 'Entregue', desc: 'Entrega concluída com confirmação de recebimento.', icone: 'mdi-check-decagram-outline' },
]

// Vazio de propósito na v1 — toda busca cai em "não encontrado".
// Exemplo de entrada, caso queira demonstrar o resultado completo:
// 'FDG-100200': {
//   codigo: 'FDG-100200', status: 'transito', origem: 'São Paulo/SP', destino: 'Guarulhos/SP',
//   previsao: '25/07/2026', atualizadoEm: '25/07/2026 às 11:40',
//   historico: [{ chave: 'coletado', data: '25/07/2026 09:12', local: 'São Paulo/SP' }],
// }
export const RASTREIOS_DEMO = {}

export function consultarRastreio(codigo) {
  const normalizado = normalizarCodigo(codigo)
  // Latência simulada pra interface de carregamento se comportar como
  // vai se comportar com a API real no lugar.
  return new Promise((resolve) => {
    setTimeout(() => {
      const achado = RASTREIOS_DEMO[normalizado] || RASTREIOS_DEMO[normalizado.replace('-', '')]
      resolve(achado ? { encontrado: true, dados: achado } : { encontrado: false })
    }, 900)
  })
}
